/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-03-28 16:41:39
 * @LastEditors: huangshimin@klcxkj.com
 * @LastEditTime: 2022-06-01 17:50:29
 * @FilePath: \client-h5\src\utils\api.js
 */
import http from './http';
import envConfig from '../config/env';
/**
 * 获取openId
 */
export function getOpenId(params) {
  return http("get", '/login/getAccessToken',params);
}
/**
 * 获取token
 */
export function getToken(params) {
  return http("get", envConfig.prepay+'/prepay-user/oauth/token?username='+params.openId+'&password=123456&grant_type=password&client_id=client&client_secret=123456&scope=all');
}



// export function getToken() {
//   return http("get", host+'prepay-user/oauth/token?username=ox7D66nDCy2qTg7ZkF1eDmad4RqE&password=123456&grant_type=password&client_id=client&client_secret=123456&scope=all');
// }